import React, { useState } from 'react';
import Pagination from '@mui/material/Pagination';
import { Button } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';

import { rootStyle } from './styles';

const AdminPagination = ({ total = 0, size = 0, onChange, forceUpdatePage, ...otherProps }) => {
  const [input, setInput] = useState('');
  const [newPage, setNewPage] = useState(1);
  const { classes: classed } = rootStyle();
  const count = Math.ceil(total / size);

  const handleChangeInput = (e) => {
    e.preventDefault();
    const { value } = e.target;
    if (value === '') {
      setInput('');
      return;
    }
    setInput(parseInt(value, 10));
  };
  const handleChangePage = (e, number) => {
    onChange(e, number);
    setNewPage(number);
  };

  const handleGoPage = (e) => {
    const goPageValue = input > count ? count : input;
    onChange(e, goPageValue);
    setNewPage(goPageValue);
    setInput('');
  };

  if (total <= size) return null;

  // Handle force update page number
  if (!isNaN(forceUpdatePage) && forceUpdatePage !== newPage - 1) {
    setNewPage(forceUpdatePage + 1);
  }

  return (
    <div className={classed.root}>
      <Pagination onChange={handleChangePage} className={otherProps?.className ? classed.greenPagination : classed.customPagination} count={count} page={newPage} {...otherProps} />
      <div className={classed.goTo}>
        <div className={classed.text}>Go to page</div>
        <input type="number" className={classed.input} onChange={handleChangeInput} value={input} min={1} />
        <Button onClick={handleGoPage} size="small" className={classed.button} endIcon={<ChevronRight className={classed.rightIcon} />}>
          Go
        </Button>
      </div>
    </div>
  );
};

export default React.memo(AdminPagination);
